export default __webpack_public_path__ + "static/media/sprite-emma-3-4.d497b83a.png";